"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SobreGuillermoBogao() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className={`transition-all duration-700 ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative overflow-hidden rounded-lg shadow-medium">
              <img src="https://logical-anemone-1.10web.cloud/wp-content/uploads/2026/01/83738947-1677-4EC7-9844-93B0810033E6-e1768479536483.jpg" alt="Guillermo Bogao" className="w-full h-auto object-cover transition-transform duration-700 ease-out-back hover:scale-105" />
            </div>
          </div>

          {}
          <div ref={rightRef} className={`transition-all duration-700 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">Quién soy y por qué hago esto</h2>
            <div className="space-y-4 text-foreground/80 text-base md:text-lg leading-relaxed">
              <p>Acompaño a personas que se sienten estancadas y saben que pueden dar más, pero  sienten que algo dentro las frena.</p>
              <p>No trabajo desde la motivación superficial. Trabajo desde la escucha, la claridad y un enfoque práctico. Mi objetivo no es que te sientas bien un día, sino ayudarte a entender qué te está bloqueando y cómo empezar a avanzar con más seguridad.</p>
              <p>Creo firmemente que cuando ordenas tu mente, todo cambia: ves mas claro, decides mejor y avanzar deja de ser tan complicado.</p>
              <p>Si sientes que necesitas un cambio real, estaré encantado de acompañarte en este proceso.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}